// extracted by mini-css-extract-plugin
export default {"advtBlock":"Advt_advtBlock__BuVaH","title":"Advt_title__p3wuN","qrsWrapper":"Advt_qrsWrapper__ztu71","qrCode":"Advt_qrCode__T+Ji4"};